<template lang="html">
    <div class="section section-grey pb-5">
        <div class="container text-center ">
            <img src="https://www.fotografi-cameramani.ro/layout/standard/images/logos/svg/fotografi-cameramani-fundal-deschis-color.svg" class="logo">

            <h3 class="mb-4">Catalogul fotografilor si cameramanilor de nunta din Romania</h3>
            <div class="mb-4">
                Ai toate motivele sa iti alegi fotograful si videograful nuntii tale de aici.
            </div>
            <a class="btn btn-dark btn-md" href="https://www.fotografi-cameramani.ro" target="_blank"><i class="fas fa-search"></i> Cauta fotograf si cameraman</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromoMembers',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.logo {
    max-width: 200px;
}

</style>
